import LoginPage from '../components/login/login-page';
import AdminLoginPage from '../components/admin/login/login-page';
import TeamLoginPage from '../components/team/login/login-page';
import Logout from '../components/logout/index';
import AdminLogout from '../components/admin/logout/index';
import TeamLogout from '../components/team/logout/index';
import OutletValidationForm from '../components/outlet-validation/outlet-validation-form';
import YourStoreForm from '../components/your-store';
import ForgottenPasswordForm from '../components/auth/forgotten-password-1';
import PINForm from '../components/auth/forgotten-password-2';
import SeqQuestionsForm from '../components/auth/security-questions';
import NewPasswordForm from '../components/auth/new-password';
import StoreSummary from '../components/store-summary/index';
import StoreSummaryReg from '../components/store-summary/index-registration';
import StoreDetails from '../components/store-details/index';
import MyStaff from '../components/my-staff/index';
import AboutYou from '../components/about-you/index';
import MyProfile from '../components/my-profile';
import AdminMyProfile from '../components/admin/my-profile';
import UpdatePassword from '../components/update-password';
import AdminUpdatePassword from '../components/admin/update-password';
import UpdateSecurityQuestions from '../components/update-security-questions';
import AdminUpdateSecurityQuestions from '../components/admin/update-security-questions';
import HomePage from '../components/home/home-page';
import AdminHomePage from '../components/admin/home/index';
import TeamHomePage from '../components/rep-home/home-page';
import Welcome from '../components/admin/welcome';
import UserGroups from '../components/admin/usergroups/list/index';
import EditUserGroup from '../components/admin/usergroups/edit/index';
import Users from '../components/admin/users/list/index';
import EditUser from '../components/admin/users/edit/edit';
import UserDetails from '../components/admin/users/edit/details';
import UserUpdateSecurityQuestions from '../components/admin/users/edit/update-security-question';
import Notifications from '../components/admin/notifications/list';
import Notification from '../components/admin/notifications/edit';
import Pages from '../components/pages';
import AddEditPages from '../components/pages/add-edit';
import PersonalRewards from '../components/personal-rewards';
import HowToEarn from '../components/how-to-earn';
import OutletView from '../components/admin/outlet-view';
import OutletList from '../components/admin/outlet-list';
import DelinkPage from '../components/admin/delink';
import SiteDesign from '../components/site-design';
import DataImport from '../components/admin/data-import';
import DataExport from '../components/admin/data-export';
import Categories from '../components/admin/products/categories/list/index';
import EditCategory from '../components/admin/products/categories/edit/index';
import Brands from '../components/admin/products/brands/list/index';
import EditBrand from '../components/admin/products/brands/edit/index';
import Products from '../components/admin/products/products/list/index';
import Settings from '../components/admin/staff-reward/settings';
import NewProduct from '../components/admin/products/products/add/index';
import PpcSettings from '../components/admin/ppc/settings';
import PpcManagement from '../components/admin/ppc/management';
import PpcUser from '../components/admin/ppc/user';
import PpcLoad from '../components/admin/ppc/load';
import PpcManualLoad from '../components/admin/ppc/load-manual';
import PointsExpiry from '../components/admin/points/points-expiry/index';
import PointsTransactions from '../components/admin/points/points-transactions/index';
import ManualPointsTransactions from '../components/admin/points/manual-points-transactions/index';
import AddIncentives from '../components/admin/incentives/add-incentives/index';
import Incentives from '../components/admin/incentives/index';
import StorePerformance from '../components/store-performance/index';
import NewsCategories from '../components/admin/news/categories/list';
import EditNewsCategories from '../components/admin/news/categories/edit';
import NewsArticles from '../components/admin/news/articles/list';
import EditNewsArticles from '../components/admin/news/articles/edit';
import QrCodeCampaigns from '../components/admin/qr-code-campaigns/list';
import NewQrCodeCampaign from '../components/admin/qr-code-campaigns/new';
import PointsStatement from '../components/points-statement/index';
import Submissions from '../components/submissions/index';
import AdminHomePageMenu from '../components/admin/homepagemenu/index';
import NewCarousel from '../components/admin/homepagemenu/add-carousel/index';
import ContactUsPre from '../components/contact-us/pre-login/index';
import ContactUsPost from '../components/contact-us/post-login/index';
import AboutIgnite from '../components/about-ignite/index';
import ContentPage from '../components/admin/content-page';
import Article from '../components/article/index';
import MyMessages from '../components/my-messages';
import TeamMyMessages from '../components/team/my-messages';
import Downloads from '../components/admin/downloads/list';
import EditDownload from '../components/admin/downloads/edit';
import TeamWelcome from '../components/team/welcome/TeamWelcome';
import Levels from '../components/admin/levels/levels';
import EditLevel from '../components/admin/levels/edit-levels';
import TeamContactUsPage from '../components/team/contact-us/contact-us-page';
import UpdateLevel from '../components/admin/update-level';
import GroupsPage from '../components/admin/groups/list/groups-page';
import GroupsFormPage from '../components/admin/groups/form/group-form-page';
import StockIt from '../components/admin/objectives/stock_it';
import AddEditStockIt from '../components/admin/objectives/stock_it/add-stock-its';
import PostcodePlans from '../components/admin/objectives/postcode_plans';
import AddEditPostcodePlan from '../components/admin/objectives/postcode_plans/add-postcode-plans';
import MyStoresListView from '../components/team/my-stores/list/list';
import MyStoresMapViewPage from '../components/team/my-stores/map/index';
import RdrNewsPage from '../components/team/latest-news/rdr-news-page';
import RetailerNewsPage from '../components/team/latest-news/retailer-news-page';
import TeamStoreDetails from '../components/team/store-details';
import PointsActivity from '../components/team/points-activity/points-activity';
import ProductsList from '../components/products-list/products-list';
import EmailLogs from '../components/admin/notifications/email/email-logs';
import EmailEdit from '../components/admin/notifications/email/edit/edit-email';
import SmsLogs from '../components/admin/notifications/sms/sms-logs';
import SmsView from '../components/admin/notifications/sms/sms-view';
import { USER_TYPE_ADMIN, USER_TYPE_REP, USER_TYPE_RETAILER } from './userTypes';
import SubmissionsPage from '../components/admin/submissions/list/submissions-page';
import AdminSubmissionFormPage from '../components/admin/submissions/form/submission-form-page';
import SubmissionFormPage from '../components/submissions/sell-it-uploader/submission-form-page';
import SubmissionsDashboard from '../components/submissions/dashboard/submissions-dashboard';
import PointsTypes from '../components/admin/points-types/list';
import EditPointsType from '../components/admin/points-types/edit';
import MarketingConsent from '../components/admin/marketing_consents';
import PasswordResetReceiver from '../components/auth/password-reset-receiver';
import EditNavigationBackgroundImages from '../components/admin/navigation/edit-background-images';
import ListNavigationLinks from '../components/admin/navigation/links/list/index';
import EditNavigationLink from '../components/admin/navigation/links/edit/index';
import ScansPage from '../components/admin/scans/scans/list/scans-page';
import ScanViewPage from '../components/admin/scans/scans/view/scan-view-page';
import DamagedBarcodeSubmissionsPage from '../components/admin/scans/damaged-barcode-submissions/list/damaged-barcode-submissions-page';
import DamagedBarcodeSubmissionViewPage
  from '../components/admin/scans/damaged-barcode-submissions/view/damaged-barcode-submission-view-page';
import ScanOverridesPage from '../components/admin/scans/scan-overrides/scan-overrides-page';
import NextAuditSubmission from '../components/admin/submissions/next-audit-submission';
import FeatureTogglesList from '../components/admin/feature-toggles/list';
import featureToggleFormPage from '../components/admin/feature-toggles/form/feature-toggle-form-page';
import MarketingPreferences from '../components/admin/marketing-preferences';
import DisabledScansPage from '../components/admin/scans/disabled-scans/disabled-scans-page';
import PipEposSubmissionsPage from '../components/admin/pip_epos_submissions/list/pip-epos-submissions-page';
import pipEposSubmissionsFormPage from '../components/admin/pip_epos_submissions/form/pip-epos-submissions-form-page';
import PipEposSubmissionsReportPage from '../components/admin/pip_epos_submissions/report/pip-epos-submissions-report-page';
import NonPpcMcSettings from '../components/admin/non_ppc_settings';
import PipEposObjectivesPage from '../components/admin/pip_epos_submissions/objectives/pip-epos-objectives-page';
import PipEposSubmissionsMissingWeeksPage
  from '../components/admin/pip_epos_submissions/missing_weeks/pip-epos-submissions-missing-weeks-page';

const urlPrefixByUserType = {
  [USER_TYPE_RETAILER]: '',
  [USER_TYPE_ADMIN]: '/admin',
  [USER_TYPE_REP]: '/team',
};

export const routes = {
  loggedInHome: {
    path: '/',
    component: HomePage,
    exact: true,
    permissions: {
      action: 'login',
      subjectClass: 'web_app',
    },
  },
  preLogInHome: {path: '/', exact: true, component: LoginPage },
  public: [
    {
      path: '/about-ignite',
      component: AboutIgnite,
    },
    {
      path: '/article/:id',
      component: Article
    },
  ]
};

export const mainRoutes = {
  private: [
    {
      path: '/',
      component: HomePage,
      exact: true,
      permissions: {
        action: 'login',
        subjectClass: 'web_app'
      }
    },
    {
      path: '/outlet',
      component: OutletValidationForm
    },
    {
      path: '/admin/news/edit-content/:id',
      component: Article
    },
    {
      path: '/store-summary',
      component: StoreSummary
    },
    {
      path: '/about-you',
      component: AboutYou
    },
    {
      path: '/store-details/:id',
      component: StoreDetails
    },
    {
      path: '/your-store',
      component: YourStoreForm
    },
    {
      path: '/my-staff',
      component: MyStaff,
      permissions: {
        action: 'handle',
        subjectClass: 'staff',
      }
    },
    {
      path: '/points-statement',
      exact: true,
      component: PointsStatement,
      permissions: {
        action: 'view',
        subjectClass: 'web_app_points',
      }
    },
    {
      path: '/my-profile',
      component: MyProfile
    },
    {
      path: '/update-password',
      component: UpdatePassword,
    },
    {
      path: '/site-design',
      component: SiteDesign
    },
    {
      path: '/store-performances',
      component: StorePerformance,
      permissions: {
        action: 'view',
        subjectClass: 'objective_info,objective_performance',
      },
    },
    {
      path: '/personal-rewards',
      component: PersonalRewards,
      permissions: {
        action: 'index',
        subjectClass: 'personal_rewards',
      },
      hidePseudo: true,
    },
    {
      path: '/how-to-earn',
      component: HowToEarn,
      permissions: {
        action: 'view',
        subjectClass: 'objective_info,objective_performance',
      },
    },
    {
      path: '/contact-us',
      component: ContactUsPost
    },
    {
      path: '/about-ignite',
      component: AboutIgnite,
      permissions: {
        action: 'view',
        subjectClass: 'web_app_view_articles',
      },
    },
    {
      path: '/article/:id',
      component: Article
    },
    {
      path: '/my-messages',
      component: MyMessages,
      permissions: {
        action: 'view',
        subjectClass: 'web_app_messages',
      }
    },
    {
      path: '/content-page/edit/:pageSlug',
      component: ContentPage,
      permissions: {
        action: 'edit',
        subjectClass: 'Page'
      }
    },
    {
      path: '/brands',
      component: ProductsList,
      permissions: {
        action: 'view',
        subjectClass: 'web_app_products_page',
      }
    },
    {
      path: '/submissions/new',
      component: SubmissionFormPage,
    },
    {
      path: '/submissions/my_dashboard',
      component: SubmissionsDashboard,
    },
    {
      path: '/submissions',
      exact: true,
      component: Submissions,
      permissions: {
        action: 'handle',
        subjectClass: 'sell_it_uploader',
      }
    }
  ]
};

export const repRoutes = {
  public: [],
  private: [
    {
      path: '/team',
      exact: true,
      component: TeamHomePage,
      permissions: {
        action: 'login',
        subjectClass: 'team_portal'
      }
    },
    {
      path: '/team/outlets/:id',
      component: TeamStoreDetails,
      exact: true,
    },
    {
      path: '/team/contact',
      component: TeamContactUsPage,
    },
    {
      path: '/team/update-security-questions',
      component: UpdateSecurityQuestions,
    },
    {
      path: '/team/update-password',
      component: UpdatePassword,
    },
    {
      path: '/team/stores/map',
      component: MyStoresMapViewPage,
      permissions: {
        action: 'view',
        subjectClass: 'store_info'
      }
    },
    {
      path: '/team/pip_epos_submissions',
      component: PipEposSubmissionsPage,
      exact: true,
      permissions: {
        action: 'index',
        subjectClass: 'PipEposSubmission',
      },
    },
    {
      path: '/team/pip_epos_submissions/:id',
      component: pipEposSubmissionsFormPage,
      permissions: {
        action: 'index',
        subjectClass: 'PipEposSubmission',
      },
    },
    {
      path: '/team/stores/list',
      component: MyStoresListView,
      permissions: {
        action: 'view',
        subjectClass: 'store_info'
      }
    },
    {
      path: '/team/contact-us',
      component: TeamContactUsPage,
    },
    {
      path: '/team/latest-news/rdr',
      component: RdrNewsPage,
      permissions: {
        action: 'view',
        subjectClass: 'article_info'
      }
    },
    {
      path: '/team/article/:id',
      component: Article,
      permissions: {
        action: 'view',
        subjectClass: 'article_info'
      }
    },
    {
      path: '/team/latest-news/retailer',
      component: RetailerNewsPage,
      permissions: {
        action: 'view',
        subjectClass: 'article_info'
      }
    },
    {
      path: '/team/about-ignite',
      component: AboutIgnite,
      permissions: {
        action: 'view',
        subjectClass: 'article_info'
      }
    },
    {
      path: '/team/logout',
      component: TeamLogout,
    },
    {
      path: '/team/outlets/:outlet/points-activity',
      component: PointsActivity,
      permissions: {
        action: 'view',
        subjectClass: 'points_rep_area'
      }
    },
    {
      path: '/team/my-profile',
      component: MyProfile,
    },
    {
      path: '/team/my-messages',
      component: TeamMyMessages,
      permissions: {
        action: 'view',
        subjectClass: 'messages_rep_area',
      }
    },
    {
      path: '/team/site-design',
      component: SiteDesign
    },
    {
      path: '/team/submissions',
      component: SubmissionsPage,
      exact: true,
      permissions: {
        action: 'handle',
        subjectClass: 'Submission',
      },
    },
    {
      path: '/team/submissions/:id',
      component: AdminSubmissionFormPage,
      permissions: {
        action: 'handle',
        subjectClass: 'Submission',
      },
    },
    {
      path: '/team/scanning-disabled',
      component: DisabledScansPage,
      permissions: {
        action: 'manage',
        subjectClass: 'ScanningDisabled'
      }
    }
  ]
};

const forgottenRoutes = ([USER_TYPE_RETAILER, USER_TYPE_REP, USER_TYPE_ADMIN].map((area) => {
  const pre = urlPrefixByUserType[area] || '';
  return [
    {
      path: '/password-reset-link/:id',
      component: PasswordResetReceiver,
      area
    },
    {
      path: `${pre}/reset-password`,
      component: ForgottenPasswordForm,
      area,
    },
    {
      path: `${pre}/enter-pin`,
      component: PINForm,
      area,
    },
    {
      path: `${pre}/seq-questions`,
      component: SeqQuestionsForm,
      area,
    },
    {
      path: `${pre}/new-password`,
      component: NewPasswordForm,
      area,
    },
  ];
})).reduce((acc, val) => acc.concat(val), []);

export const emptyRoutes = {
  public: [
    ...forgottenRoutes,
    {
      path: '/registration/outlet',
      component: OutletValidationForm
    },
    {
      path: '/registration/about-you',
      component: AboutYou
    },
    {
      path: '/users/about_you',
      component: AboutYou
    },
    {
      path: '/registration/your-store',
      component: YourStoreForm
    },
    {
      path: '/registration/store-summary',
      component: StoreSummaryReg
    },
    {
      path: '/logout',
      component: Logout,
      exact: true,
    },
    {
      path: '/admin/login',
      component: AdminLoginPage,
      area: USER_TYPE_ADMIN,
      hideFooter: true,
      exact: true,
    },
    {
      path: '/team/login',
      component: TeamLoginPage,
      hideFooter: true,
      exact: true,
    },
    {
      path: '/admin/welcome',
      component: Welcome
    },
    {
      path: '/contact',
      component: ContactUsPre
    },
    {
      path: '/team/welcome',
      component: TeamWelcome,
    }
  ],
  private: []
};

export const adminMainRoutes = [
  {
    path: '/admin',
    component: AdminHomePage,
    exact: true,
  },
  {
    path: '/admin/logout',
    component: AdminLogout,
    exact: true,
  },
  {
    path: '/admin/my-profile',
    component: AdminMyProfile,
    exact: true,
  },
  {
    path: '/admin/qr_code_campaigns',
    component: QrCodeCampaigns,
    exact: true
  },
  {
    path: '/admin/qr_code_campaigns/new',
    component: NewQrCodeCampaign,
    exact: true
  },
  {
    path: '/admin/qr_code_campaigns/:id',
    component: NewQrCodeCampaign,
    exact: true
  },
  {
    path: '/admin/homepages/:type',
    component: AdminHomePageMenu,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'home_page',
    }
  },
  {
    path: '/admin/homepage/carousel/:type/new',
    component: NewCarousel,
    exact: true,
  },
  {
    path: '/admin/homepage/carousel/:id/edit',
    component: NewCarousel,
    exact: true,
  },
  {
    path: '/admin/homepage/carousel/:id/clone',
    component: NewCarousel,
    exact: true,
  },
  {
    path: '/admin/outlets',
    component: OutletList,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet',
    }
  },
  {
    path: '/admin/outlets/:id/view',
    component: OutletView,
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet',
    }
  },
  {
    path: '/admin/outlets/delink',
    component: DelinkPage,
    permissions: {
      action: 'delink',
      subjectClass: 'Outlet',
    }
  },
  {
    path: '/admin/outlets/:id/delink',
    component: DelinkPage,
    permissions: {
      action: 'delink',
      subjectClass: 'Outlet',
    }
  },
  {
    path: '/admin/levels',
    component: Levels,
    exact: true,
    permissions: {
      action: 'read',
      subjectClass: 'Level',
    }
  },
  {
    path: '/admin/levels/new',
    component: EditLevel,
    exact: true,
    permissions: {
      action: 'add',
      subjectClass: 'Level',
    }
  },
  {
    path: '/admin/levels/:id',
    component: EditLevel,
    permissions: {
      action: 'modify',
      subjectClass: 'Level',
    }
  },
  {
    path: '/admin/update-level',
    component: UpdateLevel,
    exact: true,
    permissions: {
      action: 'read',
      subjectClass: 'Level',
    }
  },
  {
    path: '/admin/update-level/:id',
    component: UpdateLevel,
    permissions: {
      action: 'read',
      subjectClass: 'Level',
    }
  },
  {
    path: '/admin/groups',
    component: GroupsPage,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'Group',
    }
  },
  {
    path: '/admin/groups/new',
    component: GroupsFormPage,
    permissions: {
      action: 'create',
      subjectClass: 'Group',
    }
  },
  {
    path: '/admin/groups/:id/edit',
    component: GroupsFormPage,
    permissions: {
      action: 'update',
      subjectClass: 'Group',
    }
  },
  {
    path: '/admin/user-groups',
    component: UserGroups,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'UserGroup',
    }
  },
  {
    path: '/admin/user-groups/new',
    component: EditUserGroup,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'UserGroup',
    }
  },
  {
    path: '/admin/user-groups/:id',
    component: EditUserGroup,
    permissions: {
      action: 'update',
      subjectClass: 'UserGroup',
    }
  },
  {
    path: '/admin/users',
    component: Users,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'User',
    }
  },
  {
    path: '/admin/users/new',
    component: EditUser,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'User',
    }
  },
  {
    path: '/admin/users/:id/edit',
    component: EditUser,
    exact: true,
    permissions: {
      action: 'edit',
      subjectClass: 'User',
    }
  },
  {
    path: '/admin/users/:id/details',
    component: UserDetails,
    exact: true,
    permissions: {
      action: 'edit',
      subjectClass: 'User',
    }
  },
  {
    path: '/admin/users/:id/details/security-questions',
    component: UserUpdateSecurityQuestions,
    exact: true,
    permissions: {
      action: 'update',
      subjectClass: 'SecurityQuestion'
    }
  },
  {
    path: '/admin/update-password',
    component: AdminUpdatePassword
  },
  {
    path: '/admin/update-security-questions',
    component: AdminUpdateSecurityQuestions
  },
  {
    path: '/admin/pages',
    component: Pages,
    permissions: {
      action: 'index',
      subjectClass: 'Page',
    }
  },
  {
    path: '/admin/pages-add-edit/new',
    component: AddEditPages,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Page',
    }
  },
  {
    path: '/admin/pages-add-edit/:id',
    component: AddEditPages,
    permissions: {
      action: 'update',
      subjectClass: 'Page',
    }
  },
  {
    path: '/admin/pages-add-edit',
    component: AddEditPages,
    permissions: {
      action: 'update',
      subjectClass: 'Page',
    }
  },
  {
    path: '/admin/notifications',
    component: Notifications,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Notification',
    }
  },
  {
    path: '/admin/notifications/:id',
    component: Notification,
    permissions: {
      action: 'update',
      subjectClass: 'Notification',
    }
  },
  {
    path: '/admin/data-management',
    component: DataImport,
    permissions: {
      action: 'import',
      subjectClass: 'data',
    }
  },
  {
    path: '/admin/data-export',
    component: DataExport,
    permissions: {
      action: 'export',
      subjectClass: 'data',
    }
  },
  {
    path: '/admin/categories',
    component: Categories,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Category',
    }
  },
  {
    path: '/admin/categories/new',
    component: EditCategory,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Category',
    }
  },
  {
    path: '/admin/categories/:id',
    component: EditCategory,
    permissions: {
      action: 'update',
      subjectClass: 'Category',
    }
  },
  {
    path: '/admin/brands',
    component: Brands,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Brand',
    }
  },
  {
    path: '/admin/brands/new',
    component: EditBrand,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Brand',
    }
  },
  {
    path: '/admin/brands/:id',
    component: EditBrand,
    permissions: {
      action: 'update',
      subjectClass: 'Brand',
    }
  },
  {
    path: '/admin/products',
    component: Products,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Product',
    }
  },
  {
    path: '/admin/products/new',
    component: NewProduct,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Product',
    }
  },
  {
    path: '/admin/products/:id',
    component: NewProduct,
    permissions: {
      action: 'update',
      subjectClass: 'Product',
    }
  },
  {
    path: '/admin/settings',
    component: Settings,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'Setting',
    }
  },
  {
    path: '/admin/non_ppc_mc_settings',
    component: NonPpcMcSettings,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'NonPpcMcSetting'
    }
  },
  {
    path: '/admin/ppc/settings',
    component: PpcSettings,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'PrepaidCardSetting',
    },
  },
  {
    path: '/admin/ppc/management',
    component: PpcManagement,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'PpcUser',
    }
  },
  {
    path: '/admin/ppc/management/:id',
    component: PpcUser,
    exact: true,
    permissions: {
      action: 'read',
      subjectClass: 'PpcUser',
    }
  },
  {
    path: '/admin/ppc/management/:userId/loads/new',
    component: PpcManualLoad,
    exact: true,
    permissions: {
      action: 'manual-load',
      subjectClass: 'PpcUser',
    }
  },
  {
    path: '/admin/ppc/management/:userId/loads/:loadId',
    component: PpcLoad,
  },
  {
    path: '/admin/points-expiry',
    component: PointsExpiry,
    permissions: {
      action: 'manage',
      subjectClass: 'PointExpiry',
    }
  },
  {
    path: '/admin/points-transactions',
    component: PointsTransactions,
    permissions: {
      action: 'index',
      subjectClass: 'PointTransaction',
    }
  },
  {
    path: '/admin/manual-points-transactions/:id',
    component: ManualPointsTransactions,
    permissions: {
      action: 'create',
      subjectClass: 'PointTransaction',
    }
  },
  {
    path: '/admin/points-types/:id',
    component: EditPointsType,
    permissions: {
      action: 'index',
      subjectClass: 'ManagePoints',
    }
  },
  {
    path: '/admin/points-types',
    component: PointsTypes,
    permissions: {
      action: 'index',
      subjectClass: 'ManagePoints',
    }
  },
  {
    path: '/admin/incentives',
    component: Incentives,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Incentive',
    }
  },
  {
    path: '/admin/incentives/new',
    component: AddIncentives,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Incentive',
    }
  },
  {
    path: '/admin/incentives/:id',
    component: AddIncentives,
    permissions: {
      action: 'update',
      subjectClass: 'Incentive',
    }
  },
  {
    path: '/admin/news/categories',
    component: NewsCategories,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'new_categories_and_articles',
    },
  },
  {
    path: '/admin/news/categories/new',
    component: EditNewsCategories,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'NewsCategory',
    }
  },
  {
    path: '/admin/news/categories/:id',
    component: EditNewsCategories,
    permissions: {
      action: 'update',
      subjectClass: 'NewsCategory',
    }
  },
  {
    path: '/admin/news/articles',
    component: NewsArticles,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'new_categories_and_articles',
    },
  },
  {
    path: '/admin/audit/submissions',
    component: SubmissionsPage,
    exact: true,
    permissions: {
      action: 'audit',
      subjectClass: 'Submission',
    }
  },
  {
    path: '/admin/audit/submissions/next',
    component: NextAuditSubmission,
    exact: true,
    permissions: {
      action: 'audit',
      subjectClass: 'Submission'
    }
  },
  {
    path: '/admin/news/articles/new',
    component: EditNewsArticles,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Article',
    }
  },
  {
    path: '/admin/news/articles/:id',
    component: EditNewsArticles,
    permissions: {
      action: 'update',
      subjectClass: 'Article',
    }
  },
  {
    path: '/admin/downloads',
    component: Downloads,
    exact: true
  },
  {
    path: '/admin/downloads/:id',
    component: EditDownload,
  },
  {
    path: '/admin/feature-toggles',
    component: FeatureTogglesList,
    exact: true
  },
  {
    path: '/admin/feature-toggles/:id',
    component: featureToggleFormPage
  },
  {
    path: '/admin/submissions',
    component: SubmissionsPage,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'submissions',
    },
  },
  {
    path: '/admin/submissions/:id',
    component: AdminSubmissionFormPage,
    permissions: {
      action: 'index',
      subjectClass: 'submissions',
    },
  },
  {
    path: '/admin/audit/submissions/:id',
    component: AdminSubmissionFormPage,
    permissions: {
      action: 'audit',
      subjectClass: 'Submission'
    }
  },
  {
    path: '/admin/scans',
    component: ScansPage,
    exact: true,
    permissions: {
      action: 'manage-scans',
      subjectClass: 'manage_scans',
    },
  },
  {
    path: '/admin/scans/scan-overrides',
    component: ScanOverridesPage,
    exact: true,
    permissions: {
      action: 'manage-scan-override-requests',
      subjectClass: 'ScanOverrideRequests'
    }
  },
  {
    path: '/admin/scans/damaged-barcode-submissions',
    component: DamagedBarcodeSubmissionsPage,
    exact: true,
    permissions: {
      action: 'manage-damaged-barcodes',
      subjectClass: 'DamagedBarcodes'
    }
  },
  {
    path: '/admin/scans/damaged-barcode-submissions/:id',
    component: DamagedBarcodeSubmissionViewPage,
    permissions: {
      action: 'manage-damaged-barcodes',
      subjectClass: 'DamagedBarcodes'
    }
  },
  {
    path: '/admin/scans/:id',
    component: ScanViewPage,
    permissions: {
      action: 'manage-scans',
      subjectClass: 'manage_scans'
    }
  },
  {
    path: '/admin/objectives/stock-it',
    component: StockIt,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'StockIt',
    }
  },
  {
    path: '/admin/objectives/stock-it/:id',
    component: AddEditStockIt,
    permissions: {
      action: 'manage',
      subjectClass: 'StockIt',
    }
  },
  {
    path: '/admin/objectives/stock-it/new',
    component: AddEditStockIt,
    permissions: {
      action: 'manage',
      subjectClass: 'StockIt',
    }
  },
  {
    path: '/admin/objectives/postcode-plans',
    component: PostcodePlans,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'PostcodePlan',
    }
  },
  {
    path: '/admin/objectives/postcode-plans/:id/clone',
    component: AddEditPostcodePlan,
    permissions: {
      action: 'manage',
      subjectClass: 'PostcodePlan'
    }
  },
  {
    path: '/admin/objectives/postcode-plans/:id',
    component: AddEditPostcodePlan,
    permissions: {
      action: 'manage',
      subjectClass: 'PostcodePlan',
    }
  },
  {
    path: '/admin/objectives/postcode-plans/new',
    component: AddEditPostcodePlan,
    permissions: {
      action: 'manage',
      subjectClass: 'PostcodePlan',
    }
  },
  {
    path: '/admin/email-logs',
    component: EmailLogs,
    exact: true,
    permissions: {
      action: 'index-email',
      subjectClass: 'Notification',
    }
  },
  {
    path: '/admin/email-logs/:id/edit',
    component: EmailEdit,
    permissions: {
      action: 'modify-email',
      subjectClass: 'Notification',
    }
  },
  {
    path: '/admin/sms-logs',
    component: SmsLogs,
    exact: true,
    permissions: {
      action: 'index-sms',
      subjectClass: 'Notification',
    }
  },
  {
    path: '/admin/sms-logs/:id',
    component: SmsView,
    permissions: {
      action: 'index-sms',
      subjectClass: 'Notification',
    }
  },
  {
    path: '/admin/site-design',
    component: SiteDesign
  },
  {
    path: '/admin/navigation/background',
    component: EditNavigationBackgroundImages,
    permissions: {
      action: 'modify',
      subjectClass: 'NavigationImage'
    }
  },
  {
    path: '/admin/navigation/links',
    component: ListNavigationLinks,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'navigation'
    }
  },
  {
    path: '/admin/navigation/links/new',
    component: EditNavigationLink,
    permissions: {
      action: 'add',
      subjectClass: 'NavigationLink',
    }
  },
  {
    path: '/admin/navigation/links/:id/edit',
    component: EditNavigationLink,
    permissions: {
      action: 'edit',
      subjectClass: 'NavigationLink',
    }
  },
  {
    path: '/admin/marketing-preferences',
    component: MarketingPreferences,
    permissions: {
      action: 'manage',
      subjectClass: 'MarketingPreferences',
    }
  },
  {
    path: '/admin/scanning-disabled',
    component: DisabledScansPage,
    permissions: {
      action: 'manage',
      subjectClass: 'ScanningDisabled'
    }
  },
  {
    path: '/admin/pip_epos_submissions',
    component: PipEposSubmissionsPage,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'PipEposSubmission',
    },
  },
  {
    path: '/admin/pip_epos_submissions/report',
    component: PipEposSubmissionsReportPage,
    exact: true,
    permissions: {
      action: 'report',
      subjectClass: 'PipEposSubmission',
    },
  },
  {
    path: '/admin/pip_epos_missing_weeks',
    component: PipEposSubmissionsMissingWeeksPage,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'PipEposSubmission'
    }
  },
  {
    path: '/admin/pip_epos_objectives',
    component: PipEposObjectivesPage,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'PipEposObjective'
    }
  },
  {
    path: '/admin/pip_epos_submissions/:id',
    component: pipEposSubmissionsFormPage,
    permissions: {
      action: 'index',
      subjectClass: 'PipEposSubmission',
    },
  },
];

export const adminRoutes = [
  {
    path: '/admin/marketing-consent',
    component: MarketingConsent,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'MarketingConsent',
    },
  }
];
